import "./index.css"
import React, { useState, useEffect } from "react"
import Menu from "./Menu"
import Postavy from "./Postavy"
import { Hra } from "./Hra"
import Zebricek from "./Zebricek"
import type { Postava } from "./postavy-data"
import cookieBg from "./cookie-bg.png"
import bgMenu from "./bg-menu.png"

const COOKIES_LARGE = [
  { left: "6%", size: 88, dur: 16, delay: -3 },
  { left: "18%", size: 72, dur: 13, delay: -7 },
  { left: "31%", size: 80, dur: 15, delay: -10 },
  { left: "44%", size: 68, dur: 12, delay: -2 },
  { left: "57%", size: 84, dur: 17, delay: -5 },
  { left: "70%", size: 76, dur: 14, delay: -9 },
  { left: "83%", size: 90, dur: 16, delay: -4 },
  { left: "95%", size: 70, dur: 13, delay: -8 },
  { left: "12%", size: 64, dur: 14, delay: -11 },
  { left: "24%", size: 96, dur: 18, delay: -6 },
  { left: "35%", size: 74, dur: 12, delay: -1 },
  { left: "48%", size: 86, dur: 15, delay: -12 },
  { left: "61%", size: 66, dur: 13, delay: -3 },
  { left: "74%", size: 92, dur: 17, delay: -10 },
  { left: "87%", size: 78, dur: 14, delay: -5 },
  { left: "98%", size: 62, dur: 12, delay: -9 },
]
const COOKIES_SMALL = [
  { left: "10%", size: 36, dur: 11, delay: -6 },
  { left: "24%", size: 32, dur: 9, delay: -1 },
  { left: "37%", size: 40, dur: 12, delay: -4 },
  { left: "51%", size: 34, dur: 10, delay: -7 },
  { left: "65%", size: 38, dur: 11, delay: -2 },
  { left: "79%", size: 32, dur: 10, delay: -9 },
  { left: "92%", size: 36, dur: 12, delay: -5 },
  { left: "7%", size: 30, dur: 9, delay: -11 },
  { left: "16%", size: 42, dur: 12, delay: -8 },
  { left: "29%", size: 28, dur: 10, delay: -3 },
  { left: "43%", size: 44, dur: 11, delay: -10 },
  { left: "56%", size: 31, dur: 9, delay: -4 },
  { left: "69%", size: 46, dur: 12, delay: -7 },
  { left: "84%", size: 29, dur: 10, delay: -2 },
]

type Screen = "menu" | "postavy" | "hra" | "zebricek"

export default function App(): React.ReactElement {
  const [screen, setScreen] = useState<Screen>("menu")
  const [jmeno, setJmeno] = useState<string>(() => localStorage.getItem("jmeno") || "")
  const [postava, setPostava] = useState<Postava | null>(null)

  useEffect(() => {
    localStorage.setItem("jmeno", jmeno)
  }, [jmeno])

  return (
    <div className="app-root">
      <div className="game-menu-bg-layer" style={{ backgroundImage: `url(${bgMenu})` }} aria-hidden />
      <div className="cookie-rain-layer" aria-hidden style={{ zIndex: -1 }}>
        {COOKIES_LARGE.map((c, i) => (
          <img key={`cl${i}`} src={cookieBg} alt="" style={{
            position:"absolute", left:c.left, top:"-50px", width:c.size, height:c.size,
            opacity:0.28, pointerEvents:"none", objectFit:"contain",
            animation:`cookieFall ${c.dur}s linear ${c.delay}s infinite`
          }} />
        ))}
        {COOKIES_SMALL.map((c, i) => (
          <img key={`cs${i}`} src={cookieBg} alt="" style={{
            position:"absolute", left:c.left, top:"-30px", width:c.size, height:c.size,
            opacity:0.2, pointerEvents:"none", objectFit:"contain",
            animation:`cookieFallSmall ${c.dur}s linear ${c.delay}s infinite`
          }} />
        ))}
      </div>

      {screen === "menu" && (
        <Menu
          jmeno={jmeno}
          setJmeno={(v) => setJmeno(v)}
          onNovahra={() => setScreen("postavy")}
          onPostavy={() => setScreen("postavy")}
          onZebricek={() => setScreen("zebricek")}
        />
      )}

      {screen === "postavy" && (
        <Postavy
          onZpet={() => setScreen("menu")}
          onVybrat={(p) => {
            setPostava(p)
            setScreen("hra")
          }}
        />
      )}

      {screen === "hra" && postava && (
        <Hra
          onZpet={() => { setScreen("menu"); setPostava(null) }}
          postava={postava}
          jmeno={jmeno}
        />
      )}

      {screen === "zebricek" && (
        <Zebricek onZpet={() => setScreen("menu")} />
      )}
    </div>
  )
}